import TaskCard from "@components/dashboard/tasks/TaskCard.tsx";
import useTask from "@hooks/use_task.tsx";
import useTranslation from "@hooks/use_translation.ts";

const TASKABLE_TYPE = "JobSearchQuickApply";

export const JobSearchQuickApply = () => {
  const { t } = useTranslation("tasks");
  const { data: task } = useTask(TASKABLE_TYPE);

  if (!task) return null;
  return (
    <TaskCard
      task={task}
      title={t("jobSearchQuickApply.title")}
      description={t("jobSearchQuickApply.description")}
      actionText={t("jobSearchQuickApply.completeProfile")}
      className={"job-search"}
      actionHref="/quick_apply"
      externalLink={false}
      redirectTo={""}
      taskableType={TASKABLE_TYPE}
    />
  );
};
